<template>
    <v-btn small text class="pa-0" v-bind="{ loading }" @click="toggleSchedule">
        <v-simple-checkbox :value="isChecked" dense hide-details color="primary" style="pointer-events: none;" v-bind="{ disabled }" />
        <span :class="{ 'grey--text': disabled }"> {{ time }}시</span>
    </v-btn>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        loading: { type: Boolean, default: false },

        schedules: { type: Array, default: () => [] },
        item: { type: Object, default: () => ({}) },
        date: { type: String },
        time: { type: Number },
        _user: { type: String },
        limitationMet: { type: Boolean, default: false },
    },
    computed: {
        schedule() {
            const { date, time, _user } = this;
            return { _subject: this.item?._id, _user, date, time };
        },
        isChecked() {
            let { _subject, date, time } = this.schedule;
            return this.schedules.some((item) => item._subject == _subject && item.date == date && item.time == time);
        },
        disabled() {
            let hasTimePassed = dayjs().isAfter(dayjs(this.date).set("hour", this.time));
            if (hasTimePassed) return true;

            let hasSchedule = this.item.schedulesOnCloud.some(({ datetime }) => dayjs(datetime).isSame(dayjs(this.date).set("hour", this.time), "hour"));
            if (hasSchedule) return true;

            return !this.isChecked && this.limitationMet;
        },
    },
    methods: {
        toggleSchedule() {
            if (this.isChecked) this.$emit("del", this.schedule);
            else if (this.limitationMet) alert("한 주 동안 3시간을 초과해 대여할 수 없습니다");
            else if (this.disabled) alert("마감된 스케줄입니다");
            else this.$emit("add", this.schedule);
        },
    },
};
</script>

<style scoped></style>
